import { ImageRounded } from "@mui/icons-material";

export const image = (props) => {
  return <ImageRounded {...props} />;
};
